/*
 * GET INVOICES
 */
export const UPDATE_CLIENT_USER = "UPDATE_CLIENT_USER"
export const UPDATE_CLIENT_USER_SUCCESS = "UPDATE_CLIENT_USER_SUCCESS"
export const UPDATE_CLIENT_USER_ERROR = "UPDATE_CLIENT_USER_ERROR"
